var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 91,
    viewBox: "0 0 84 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 60.9405L40.875 69.9317L36.5 65.8448",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.347 9.76145C32.0955 6.07339 37.1859 3.9961 42.5 3.9961C47.8141 3.9961 52.9045 6.07339 56.653 9.76145C60.4004 13.4485 62.5 18.4427 62.5 23.6436V38.962H22.5V23.6436C22.5 18.4427 24.5996 13.4485 28.347 9.76145ZM18.5 38.962V23.6436C18.5 17.363 21.0361 11.3459 25.5403 6.9143C30.0434 2.48372 36.1446 0 42.5 0C48.8554 0 54.9566 2.48372 59.4597 6.9143C63.9639 11.3459 66.5 17.363 66.5 23.6436V38.962H72.7222C78.6637 38.962 83.5 43.7492 83.5 49.6788V80.1944C83.5 86.124 78.6637 90.9112 72.7222 90.9112H11.2778C5.33627 90.9112 0.5 86.124 0.5 80.1944V49.6788C0.5 43.7492 5.33627 38.962 11.2778 38.962H18.5ZM64.5 42.958H20.5H11.2778C7.52362 42.958 4.5 45.9779 4.5 49.6788V80.1944C4.5 83.8953 7.52362 86.9151 11.2778 86.9151H72.7222C76.4764 86.9151 79.5 83.8953 79.5 80.1944V49.6788C79.5 45.9779 76.4764 42.958 72.7222 42.958H64.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 78.9229C51.232 78.9229 57.5 72.661 57.5 64.9366C57.5 57.2122 51.232 50.9503 43.5 50.9503C35.768 50.9503 29.5 57.2122 29.5 64.9366C29.5 72.661 35.768 78.9229 43.5 78.9229Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockSuccess);
export default __webpack_public_path__ + "static/media/lockSuccess.a1b3ab776eb01393ae6b7d6890d79e76.svg";
export { ForwardRef as ReactComponent };